import { useCallback, useEffect, useState } from "react";
export const useSubmitWithRedirect = (onSubmit)=>{
    // Redirecting Modal
    const [isRedirecting, setRedirecting] = useState(false);
    const handleUnload = ()=>setRedirecting(false);
    useEffect(()=>{
        const handlePageshow = ()=>{
            if (document.visibilityState === 'hidden') {
                handleUnload();
            }
        };
        window.addEventListener('visibilitychange', handlePageshow);
        return ()=>{
            window.removeEventListener('visibilitychange', handlePageshow);
        };
    }, []);
    // Form
    const finalOnSubmit = useCallback(async (values)=>{
        setRedirecting(true);
        await onSubmit(values);
    }, [
        onSubmit
    ]);
    return {
        onSubmit: finalOnSubmit,
        isRedirecting,
        setRedirecting
    };
};
export default useSubmitWithRedirect;

//# sourceMappingURL=useSubmitWithRedirect.js.map